import React, { useState, useEffect, useMemo } from "react";
import { AuthRouting } from "../Routes/AuthRouting";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { authTitles } from "../Utils/constants.api";
import { Button, Dialog, DialogActions, DialogTitle } from "@material-ui/core";

export const AuthLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const [open, setOpen] = useState(false);
  const memoizedTitle = useMemo(
    () => authTitles.get(location.pathname),
    [location.pathname]
  );

  useEffect(() => {
    const route = location.pathname.replace(/\/$/, "");
    setTitle(authTitles.get(route));
  }, [memoizedTitle]);

  const handleDialog = (option) => {
    setOpen((cur) => option);
  };

  const LogOutDialog = () => (
    <Dialog open={open} onClose={() => handleDialog(false)}>
      <DialogTitle id="alert-dialog-title">
        {`¿Estás seguro que deseas salir de la pantalla de ${String(
          title
        ).toLowerCase()}?`}
      </DialogTitle>
      <DialogActions>
        <Button onClick={() => handleDialog(false)}>Cancelar</Button>
        <Button
          onClick={() => {
            handleDialog(false);
            navigate("/");
          }}
          autoFocus
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <section className="auth-layout flex justify-center items-center">
      <LogOutDialog />
      <div className="bg-white rounded shadow-md p-0 my-4 min-w-[60%] tab-port:min-w-[50%] tab-land:min-w-[35%] big-desktop:min-w-[20%]">
        <div className="flex justify-between px-8 py-6 bg-[#F8F8F8] shadow shadow-bd-light rounded-tl rounded-tr">
          <span className="uppercase text-xl text-primary-dark font-extrabold">
            {title}
          </span>
          <button className="text-danger" onClick={() => handleDialog(true)}>
            <AiOutlineCloseCircle
              fontSize={"1.8rem"}
              fontWeight={700}
            ></AiOutlineCloseCircle>
          </button>
        </div>
        <div className="px-16 tab-land:px-20 pt-10 pb-12 text-center">
          <Outlet />
          <AuthRouting></AuthRouting>
        </div>
      </div>
    </section>
  );
};
